import { RestorePasswordState } from '../../store/state';
import { RestorePasswordAction, RestorePasswordActions } from '../actions/restore.action';

const initialState: RestorePasswordState = {
  success: false,
  isLoading: false,
  errorText: ''
};

const restoreReducer = (state: RestorePasswordState = initialState, action: RestorePasswordAction) => {
  switch (action.type) {
    case RestorePasswordActions.RestorePassword:
      return {
        ...state,
        isLoading: true,
        success: false,
        errorText: '',
      };
    case RestorePasswordActions.RestorePasswordSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
        errorText: '',
      };
    case RestorePasswordActions.RestorePasswordError:
      return {
        ...state,
        success: false,
        isLoading: false,
        errorText: action.payload
      };
    case RestorePasswordActions.ResetState:
      return {
        ...state,
        success: false,
        isLoading: false,
        errorText: null
      };
    default:
      return state;
  }
};

export default restoreReducer;
